import DefineDataGroup from './DefineDataGroup.js';
import {authRoles} from "../../../auth/auth";

export const DefineDataGroupConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: true
                },
                toolbar: {
                    display: true
                },
                footer: {
                    display: false
                }
            }
        }
    },
    auth: authRoles.exceptViewer,
    routes: [
        {
            path: ['/create-group', '/edit-group'],
            component: DefineDataGroup
        }
    ]
};




// WEBPACK FOOTER //
// ./src/main/content/define-data-group/DefineDataGroupConfig.js